import Joi from "joi";

const WardMasterSchema = Joi.object({
  wardName: Joi.string().trim().required().messages({
    "string.empty": "Ward Name is required.",
  }),

  priority: Joi.number().min(0).required().messages({
    "number.base": "Priority must be a number.",
    "number.min": "Priority cannot be negative.",
  }),
  contactNumber: Joi.string()
    .trim()
    .allow("")
    .pattern(/^$|^\d{10}$/)
    .messages({
      "string.pattern.base":
        "Contact number must be exactly 10 digits, or leave the field empty.",
    }),
  // matronInCharge: Joi.string().trim().required().messages({
  //   "string.empty": "Matron In Charge is required.",
  // }),
}).unknown(true);

export default WardMasterSchema;
